/* stylelint-disable selector-max-compound-selectors, max-nesting-depth */

:host {
    header {
        height: var(--header-height);
        background-color: $color-grey-01-dark;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        transition:
            height 300ms,
            background-color 300ms;
    }

    .grid {
        @include grid;

        height: 100%;
    }

    .logo {
        margin-top: 28px;
        line-height: 0;

        .svg {
            width: 94px;
            height: 68px;
            color: $color-red;
            transition:
                width 300ms,
                height 300ms;
            overflow: hidden;
        }

        &.swiss {
            margin-top: 20px;

            .svg {
                width: 100px;
                height: 80px; // 76px

                svg {
                    transform: scale(1);
                    transition: transform 300ms linear;
                    transform-origin: center top;
                }
            }
        }

        &.brasil {
            margin-top: 28px;

            .svg {
                width: 103px;
                height: 68px;
            }
        }

        &.france {
            margin-top: 28px;

            .svg {
                width: 91px;
                height: 68px;
            }
        }

        a {
            display: inline-block;
        }

        svg {
            width: 100%;
            height: auto;
        }
    }

    .claim {
        opacity: 1;
        transition: opacity 300ms;
    }

    .qrcode {
        display: none;
    }

    .menu-toggle-btn,
    .menu-close-btn {
        all: unset;
        cursor: pointer;
        color: $color-white;
        margin-left: 44px;
        visibility: hidden;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;

        .svg {
            width: 38px;
            margin: -8px -5px;
        }
    }

    .menu-close-btn {
        animation: closeButtonEnter 300ms linear forwards;

        &.close-animation {
            animation: closeButtonLeave 300ms linear forwards;
        }
    }
}

.service-navigation {
    margin-right: -88px;
    margin-top: 32px;
    grid-column: 3;
    visibility: hidden;

    > .actions-container {
        display: flex;
        column-gap: 16px;

        sew-ws-flyout {
            z-index: 12;
        }
    }
}

.has-no-main-navigation {
    .service-navigation {
        margin-top: 40px;
    }
}

// the flyout must not have the arrow for mq3 but it can have one, if there is no main navigation
@include mq-3-only {
    .sub-grid {
        .header-search {
            --arrow-display: none;
        }
    }
}

.sub-grid {
    grid-column: 2 / -1;
    display: grid;
    grid-template-columns: 160px 1fr auto 40px;

    &.has-no-main-navigation {
        .header-search {
            --arrow-display: block;
        }

        .service-navigation {
            position: relative;
            left: -88px;
        }
    }
}

.main-navigation {
    @include typo-ws-paragraph-bold;

    display: flex;
    gap: 24px;
    align-self: flex-end;
    padding: 0 20px 20px 0;
    overflow: hidden;
    visibility: hidden;

    button {
        all: unset;
        color: $color-white;
        cursor: pointer;
        white-space: nowrap;

        &:hover,
        &.active {
            text-decoration: underline;
            text-decoration-thickness: 2px;
            text-underline-offset: 5px;
        }
    }
}

.visible {
    visibility: visible !important;
}

:host([transparent]:not(.scrolled)) {
    header {
        background-color: transparent;
    }
}

:host(.scrolled) {
    header {
        height: var(--header-height-scrolled);
    }

    .logo {
        margin-top: 24px;

        .svg {
            width: 83px;
            height: 40px;
        }

        &.swiss {
            margin-top: 16px;

            .svg {
                width: 56px;
                height: 57px;

                svg {
                    transform: scale(2.1) translate3d(0, 0, 0);
                }
            }
        }

        &.brasil {
            margin-top: 20px;

            .svg {
                width: 73px;
                height: 48px;
            }
        }

        &.france {
            margin-top: 24px;

            .svg {
                width: 83px;
                height: 44px;
            }
        }
    }

    .claim {
        opacity: 0;
    }

    .navigation-container {
        margin-top: unset;
    }

    .service-navigation {
        margin-top: 34px;
    }

    .has-no-main-navigation {
        .service-navigation {
            margin-top: 0;
            align-self: center;
        }
    }
}

.header-gap {
    height: calc(var(--header-height) + 40px);
}

.header-gap + sew-ws-breadcrumb {
    margin-top: -40px;
}

:host(.breadcrumb-below-stage),
:host(.has-no-breadcrumb) {
    .header-gap {
        height: calc(var(--header-height));
    }

    .header-gap + sew-ws-breadcrumb {
        margin-top: 0;
    }
}

@include mq-4-min {
    :host {
        .sub-grid {
            grid-column: 2/-2;
            margin-right: 0;
        }
    }
}

@include mq-2 {
    :host {
        .logo {
            margin-top: 20px;

            .svg {
                width: 89px;
                height: 64px;
            }

            &.swiss {
                margin-top: 16px;

                .svg {
                    width: 89px;
                    height: 68px;
                }
            }

            &.brasil {
                margin-top: 24px;

                .svg {
                    width: 85px;
                    height: 56px;
                }
            }

            &.france {
                margin-top: 20px;

                .svg {
                    width: 85px;
                    height: 64px;
                }
            }
        }
    }

    :host(.scrolled) {
        .logo {
            margin-top: 20px;

            .svg {
                width: 87px;
                height: 40px;
            }

            &.swiss {
                margin-top: 16px;

                .svg {
                    width: 48px;
                    height: 48px;
                }
            }

            &.brasil {
                margin-top: 16px;

                .svg {
                    width: 73px;
                    height: 48px;
                }
            }

            &.france {
                margin-top: 20px;

                .svg {
                    width: 83px;
                    height: 40px;
                }
            }
        }
    }

    .service-navigation {
        margin-top: 0 !important;
        align-self: center;
    }

    .has-no-main-navigation {
        .service-navigation {
            margin-top: 32px;
        }
    }
}

@mixin mq-1-styles {
    .logo {
        margin-top: 16px;

        .svg {
            width: 69px;
            height: 32px;
        }

        &.swiss {
            margin-top: 12px;

            .svg {
                width: 40px;
                height: 40px;

                svg {
                    transform: scale(2.1);
                }
            }
        }

        &.brasil {
            margin-top: 12px;

            .svg {
                width: 60px;
                height: 40px;
            }
        }

        &.france {
            margin-top: 16px;

            .svg {
                width: 67px;
                height: 32px;
            }
        }
    }

    .claim {
        display: none;
    }

    .menu-toggle-btn,
    .menu-close-btn {
        margin-left: 19px;
    }

    .sub-grid {
        grid-template-columns: 160px 1fr auto 20px;
    }

    .service-navigation {
        margin-top: 0 !important;
        align-self: center;

        > .actions-container {
            column-gap: 13px;
        }
    }
}

@include mq-1 {
    :host,
    :host(.scrolled) {
        @include mq-1-styles;
    }
}

:host(.small),
:host(.scrolled.small) {
    --header-height: 64px;
    --header-height-scrolled: 64px;

    @include mq-1-styles;
}

:host([minimalized]) {
    .header-gap {
        height: calc(var(--header-height-scrolled));
    }
}

:host([application-context]) {
    .grid {
        max-width: none;
        grid-template-columns: repeat(12, 1fr);
        padding: 0 32px;
    }

    .sub-grid {
        grid-column: 1 / -1;
    }

    @include mq-4-min {
        .sub-grid {
            grid-column: 1 / -1;
            margin-right: 0;
        }
    }

    sew-ws-breadcrumb {
        padding: 0 32px;
    }
}

:host([application-context]),
:host(.scrolled[application-context]) {
    .sub-grid {
        grid-template-columns: 160px 1fr auto;
    }
}

@keyframes closeButtonEnter {
    from {
        transform: rotate(0);
        opacity: 0;
    }

    to {
        transform: rotate(90deg);
        opacity: 1;
    }
}

@keyframes closeButtonLeave {
    from {
        transform: rotate(90deg);
        opacity: 1;
    }

    to {
        transform: rotate(0);
        opacity: 0;
    }
}

@media print {
    :host {
        header {
            background-color: transparent;
            position: static;
        }

        .claim {
            fill: $color-black;
        }

        .main-navigation,
        .service-navigation {
            display: none;
        }

        .header-gap {
            display: none;
        }

        .qrcode {
            display: block;
            justify-self: flex-end;
            margin-top: 16px;
        }
    }
}
